import { traverse } from '@atlaskit/adf-utils/traverse';
import type { ADFEntity } from '@atlaskit/adf-utils/types';

/**
 * Extends traverse from @atlaskit/adf-utils to also walk into nestedContent
 * found in extension parameters (e.g. legacy-content, column macro).
 *  "content": [
        {
          "type": "extension",
          "attrs": {
            "extensionKey": "legacy-content",
            "extensionType": "com.atlassian.confluence.migration",
            "parameters": {
              "reason": "A column macro in a rich body macro can't be created or edited in the new editor.",
              "nestedContent": {
                "type": "doc",
                "content": [
                  {
                    "type": "bodiedExtension",
                    "attrs": {
                      "extensionType": "com.atlassian.confluence.macro.core",
                      "extensionKey": "column"
                  }
                ]
              }
            }
          }
        }
      ]
    }
  }
]
 */
export function traverseWithNestedContent(
	adf: ADFEntity,
	visitor: (node: ADFEntity) => void,
): void {
	traverse(adf, {
		any: (node) => {
			visitor(node);

			const nestedContent = node?.attrs?.parameters?.nestedContent;
			if (nestedContent?.content) {
				traverseWithNestedContent(nestedContent as ADFEntity, visitor);
			}

			return node;
		},
	});
}
